import { useContent } from '@/content'
import { useDocumentMeta } from '@/hooks'
import { Reveal, Section } from '@/components/ui'
import { WorkBrowser } from '@/features/projects'
import { SocialPanels } from '@/features/social'

/**
 * Every project, once, in one filterable grid.
 *
 * Filters live in the URL so a domain card on the home page links straight
 * into the right view, and any filtered state can be shared.
 */
export const ProjectsPage = () => {
  const { site } = useContent()
  useDocumentMeta({
    title: `Work - ${site.name}`,
    description:
      'Software engineering, design and infrastructure work — web and mobile apps, brand and design systems, deployment and network architectures.',
  })

  return (
    <>
      <Section spacious>
        <h1 className="visually-hidden">Work</h1>
        <WorkBrowser />
      </Section>

      <Reveal>
        <SocialPanels />
      </Reveal>
    </>
  )
}
